import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';

import App from './App';
import { brand } from './shared/branding/brand';
import './shared/styles/geist.css';
import { GlobalStyle } from './shared/styles/globalStyles';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { theme } from './shared/theme/theme';

// eslint-disable-next-line unused-imports/no-unused-imports-ts
import i18n from './locale/i18n';
import { I18nextProvider } from 'react-i18next';
import moment from 'moment-timezone';
import { setLoginAsTokenFromLocation } from './shared/config/securityOptions';

moment.updateLocale('en', {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
});

// Ops "Login as user": capture #loginAs= before Auth0 / routing runs.
setLoginAsTokenFromLocation();

// Brand-aware tab title (host-resolved brand); a page may still override it via
// Helmet. One static index.html serves both hosts, so the brand title is set here.
document.title = `${brand.displayName} — Vendor Portal`;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_KEY ?? '61c35a35d8fdf20ec09592ac',
    user: { key: 'anon-user', anonymous: true },
  });

  root.render(
    <HelmetProvider>
      <GlobalStyle />
      <LDProvider>
        <ThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </ThemeProvider>
      </LDProvider>
    </HelmetProvider>
  );
})();
